import { useState } from "react";

const FAQSection = ({ faqs, title = "Frequently Asked Questions" }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <span className="text-sm uppercase tracking-widest text-muted-foreground font-bold">
          FAQ
        </span>
        <h2 className="text-4xl md:text-5xl font-semibold text-foreground mt-4">
          {title}
        </h2>
      </div>

      <div className="max-w-4xl mx-auto space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-[#E2E8F0] rounded-xl bg-card shadow-[0_2px_8px_rgba(0,0,0,0.05)]"
          >
            <button
              onClick={() => toggleFaq(index)}
              className="w-full text-left p-6 flex justify-between items-center"
            >
              <span className="text-lg font-medium text-foreground">{faq.question}</span>
              <span className="text-muted-foreground text-xl">{openIndex === index ? "−" : "+"}</span>
            </button>

            {openIndex === index && (
              <div className="px-6 pb-6 text-muted-foreground">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
